module.exports = __webpack_public_path__ + "img/dy.858abcb8.png";